import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'pop-ui-cookie-settings-dialog',
  standalone: true,
  imports: [MatSlideToggleModule, MatButtonModule, MatDividerModule, FormsModule, MatIconModule ],
  template: `
  <div class="dialog-container">
    <div class="dialog-header">
      <h2 class="dialog-title">Manage Cookies</h2>
      <button mat-icon-button class="close-button" (click)="dialogRef.close()" aria-label="Close dialog">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="dialog-content">
      <div class="cookie-category">
        <div class="category-header">
          <h3>Necessary</h3>
          <div class="toggle-container">
            <span class="toggle-label">Always on</span>
          </div>
        </div>
        <p class="category-description">
          Required to enable core site functionality and to remember user preferences and choices.
        </p>
      </div>

      <mat-divider ></mat-divider>

      <div class="cookie-category">
        <div class="category-header">
          <h3>Performance and Analytics</h3>
          <div class="toggle-container">
            <span class="toggle-label">{{ data.performance ? 'On' : 'Off' }}</span>
            <mat-slide-toggle [(ngModel)]="data.performance"></mat-slide-toggle>
          </div>
        </div>
        <p class="category-description">
          These cookies provide quantitative measures of website visitors to improve site performance.
        </p>
      </div>

      <mat-divider></mat-divider>

      <div class="cookie-category">
        <div class="category-header">
          <h3>Advertising</h3>
          <div class="toggle-container">
            <span class="toggle-label">{{ data.advertising ? 'On' : 'Off' }}</span>
            <mat-slide-toggle [(ngModel)]="data.advertising"></mat-slide-toggle>
          </div>
        </div>
        <p class="category-description">
          These cookies are used by advertising companies to serve relevant ads.
        </p>
      </div>
    </div>

    <div class="dialog-actions">
      <button mat-raised-button color="primary" (click)="save()" cdkFocusInitial>Save Preferences</button>
    </div>
  </div>
  `,
  styleUrls: ['./cookie-settings-dialog.component.scss']
})
export class CookieSettingsDialogComponent {
  readonly dialogRef = inject(MatDialogRef<CookieSettingsDialogComponent>);
  readonly data = inject(MAT_DIALOG_DATA);

  save() {
    this.dialogRef.close(this.data);
  }
}
